module.exports = __webpack_public_path__ + "img/tickets-r3-mgt-admin-services.17f8579a.png";